export const styles = {
	wrapper: {
		display: 'grid',
		gridTemplateColumns: '1fr',
		gap: '16px',
		paddingTop: '32px',
		paddingX: '20px',
	},

	card: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		borderRadius: '8px',
		border: ' 1px solid var(--primary-500)',
		backgroundColor: '#FFFFFF',
		height: '60px',

		'&:hover': {
			boxShadow: 'var(--box-shadow--1)',
		},

		'@media (min-width: 640px)': {
			height: '200px',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
			borderRadius: '12px',
		},
	},

	textWrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '12px',
		paddingLeft: '16px',

		'@media (min-width: 640px)': {
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
			gap: '24px',
			paddingLeft: '0px',
		},
	},

	text: {
		fontWeight: '700',
		fontSize: '16px',
		textAlign: 'center',

		'@media (min-width: 640px)': {
			fontSize: '24px',
		},
	},

	icon: {
		svg: {
			width: '24px',
			height: '24px',
			path: {
				fill: 'var(--primary-500)',
			},

			'@media (min-width: 640px)': {
				width: '48px',
				height: '48px',
			},
		},
	},
	arrow: {
		display: 'block',
		padding: '16px',

		svg: {
			width: '20px',
			height: '20px',
			path: {
				fill: 'var(--primary-500)',
			},
		},

		'@media (min-width: 640px)': {
			display: 'none',
		},
	},

	customeModal: {
		'.MuiPaper-root': {
			maxWidth: '770px',
			paddingTop: '48px',
			paddingLeft: '120px',
			paddingRight: '120px',
			width: '100%',

			'@media (max-width: 640px)': {
				paddingTop: '40px',
				paddingLeft: '20px',
				paddingRight: '20px',
			},
		},
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '770px',
			padding: '48px 120px',
			width: '100%',

			'@media (max-width: 640px)': {
				padding: '40px 20px 20px 20px',
			},
		},
	},
};
